import React, { useEffect, useState } from "react";
import { Search, ShoppingBag, User, Menu, X } from "lucide-react";
import { NAV_CATEGORIES, SUB_NAV } from "@/mock";
import { useCart } from "@/context/CartContext";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { count, toggleDrawer } = useCart();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-40 transition-[background,backdrop-filter,border-color] duration-300 ${
        scrolled
          ? "bg-[#0b0b0c]/90 backdrop-blur-md border-b border-[#1c1c1e]"
          : "bg-[#0b0b0c] border-b border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-[72px]">
          <button
            className="lg:hidden text-[#e9d9b0]"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>

          <a href="#top" className="flex items-center gap-2 group">
            <span className="font-serif italic text-[#c9a24a] text-2xl tracking-wide group-hover:opacity-90">
              Jhumar
            </span>
            <span className="text-[#e9d9b0] text-sm tracking-[0.35em] uppercase hidden sm:inline">
              Collection
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-9">
            {NAV_CATEGORIES.map((c) => (
              <a
                key={c}
                href={`#${c.toLowerCase().replace(" ", "-")}`}
                className="text-[13px] uppercase tracking-[0.18em] text-[#e9d9b0] hover:text-[#c9a24a] transition-colors"
              >
                {c}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-4 text-[#e9d9b0]">
            <button className="hover:text-[#c9a24a] transition-colors" aria-label="Search">
              <Search size={18} />
            </button>
            <button className="hover:text-[#c9a24a] transition-colors hidden sm:block" aria-label="Account">
              <User size={18} />
            </button>
            <button
              onClick={toggleDrawer}
              className="relative hover:text-[#c9a24a] transition-colors"
              aria-label="Bag"
            >
              <ShoppingBag size={18} />
              {count > 0 && (
                <span className="absolute -top-2 -right-2 bg-[#c9a24a] text-[#0b0b0c] text-[10px] font-semibold h-4 min-w-[16px] px-1 rounded-full flex items-center justify-center">
                  {count}
                </span>
              )}
            </button>
          </div>
        </div>

        <div className="hidden lg:flex items-center justify-center gap-8 py-3 border-t border-[#1c1c1e]">
          {SUB_NAV.map((s) => (
            <a
              key={s}
              href="#"
              className="text-[12px] uppercase tracking-[0.22em] text-[#a9a294] hover:text-[#c9a24a] transition-colors"
            >
              {s}
            </a>
          ))}
        </div>

        {open && (
          <div className="lg:hidden py-4 border-t border-[#1c1c1e] flex flex-col gap-4">
            {NAV_CATEGORIES.map((c) => (
              <a
                key={c}
                href={`#${c.toLowerCase().replace(" ", "-")}`}
                onClick={() => setOpen(false)}
                className="text-sm uppercase tracking-[0.18em] text-[#e9d9b0]"
              >
                {c}
              </a>
            ))}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
